import type { PublicFooter as PublicFooterData } from '@/entities/publicReport';

export interface PublicFooterProps {
    footer: PublicFooterData;
    /** Zonder de disclaimer onder het volledige rapport: daar staat hij als hoofdstuk Voorwaarden. */
    withDisclaimer?: boolean;
}

/**
 * De voet: normdisclaimer, bedrijf en KvK. Alleen het keuringsbedrijf: de koper
 * kreeg het rapport van hem, en Smartkeur staat nergens op deze pagina.
 */
export function PublicFooter({ footer, withDisclaimer = true }: PublicFooterProps) {
    const line = [
        withDisclaimer ? footer.disclaimer : '',
        [footer.company, footer.kvk ? `KvK ${footer.kvk}` : null, ...footer.memberships]
            .filter(Boolean)
            .join(' · '),
    ]
        .filter((part) => part !== '')
        .join(' ');

    return (
        <footer className="bg-[var(--surface-subtle)] px-[var(--pr-pad-x)] pt-5 pb-[26px]">
            <p className="m-0 text-[12px] leading-[1.6] text-[var(--text-muted-mono-safe)]">
                {line}
            </p>
        </footer>
    );
}
